import { useFetchUserProfile } from '@/api/queries/userProfile/useFetchUserProfile';
import { AppRoutes } from '@/utils';
import { useMemo } from 'react';

export const useUserProfile = () => {
  const { data } = useFetchUserProfile();

  return useMemo(() => {
    const registrationDone = !!data?.disclaimerRead;
    return { ...data, userHomeRoute: AppRoutes.CUSTOMER_FOCUS, registrationDone };
  }, [data]);
};

export default useUserProfile;
